import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

const REPORT_BASE_URL = process.env.REACT_APP_REPORT_BASE_URL;

export const fetchTransactions = async (lng = "english", params) => {
  const { accessToken } = await getStorage();

  if (!params.merchantId) return;

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const options = {
      method: "GET",
      url: `${api("report")}/merchant/transactions`,
      params,
      headers,
    };
    const data = await axios(options);

    return data?.data || {};
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_transactions);
  }
};

export const fetchTransactionsSummary = async (lng = "english", params) => {
  const { accessToken } = await getStorage();

  if (!params.merchantId) return;

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const options = {
      method: "GET",
      url: `${api("report")}/merchant/transactions/summary`,
      params,
      headers,
    };

    const data = await axios(options);

    return data?.data || {};
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_transactions_summary);
  }
};

export const fetchTransactionsReversalsSummary = async (
  lng = "english",
  params
) => {
  const { accessToken } = await getStorage();

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${accessToken}`,
  };

  if (!params.merchantId) return;

  try {
    const options = {
      method: "GET",
      url: `${api("report")}/merchant/reversals/summary`,
      params,
      headers,
    };

    const data = await axios(options);

    return data?.data || {};
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_transactions_summary);
  }
};

export const fetchTransactionsReversals = async (lng = "english", params) => {
  const { accessToken } = await getStorage();

  if (!params.merchantId) return;

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const options = {
      method: "GET",
      url: `${api("report")}/merchant/reversals`,
      params,
      headers,
    };

    const data = await axios(options);

    return data?.data || {};
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchShifts = async (lng = "english", params) => {
  const { accessToken } = await getStorage();

  if (!params.merchantId) return;

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const options = {
      method: "GET",
      url: `${api("report")}/merchant/shifts`,
      params,
      headers,
    };
    const data = await axios(options);

    return data?.data || {};
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_shifts);
  }
};

export const fetchShiftTransactions = async (lng = "english", params) => {
  const { accessToken } = await getStorage();

  if (!params.merchantId) return;

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const options = {
      method: "GET",
      url: `${api("report")}/merchant/shifts/transactions`,
      params,
      headers,
    };

    const data = await axios(options);

    return data?.data || {};
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_transactions);
  }
};